import React, {useState, useEffect}    from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { Row } from 'react-bootstrap';
import AuthorizationWrapper from '../../components/authorizationWrapper';
import { actions as securityIncidentActions } from '../../ducks/securityIncidents/securityIncident.index';
import ComposeEmailTool          from './ComposeEmailTool';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import './breadcrumbs.css'
const mapStateToProps = ({securityIncidentState}, props) => {
  let commId;
  let companyId;
  let id;
  commId = props.match.params['comm_id'];
  companyId = props.match.params['company_id'];
  id = props.match.params['id'];
  return {
    commId              : commId,
    companyId           : companyId,
    id                  : id,
    emailsLoading : securityIncidentState.emailsLoading,
    commTypesLoading    : securityIncidentState.commTypesLoading,
    emails        : securityIncidentState.emails,
    comms           : securityIncidentState.comms,
    commTypes           : securityIncidentState.commTypes,
  
  }
};

const mapDispatchToProps = (dispatch) => {
const combinedActionCreators = {
  requestEmails              : securityIncidentActions.requestEmails,
  requestCommTypes                 : securityIncidentActions.requestCommTypes,
  requestComms                       : securityIncidentActions.requestComms,
};
return bindActionCreators(combinedActionCreators, dispatch);
};
const styles = {
  'topContainer': {
    'margin'   :  'auto',
    'maxWidth' :  'max-content',
    'minWidth': '73vw',
  },
  'pageTitle': {
    'textAlign'    :  'center',
    'marginLeft'   :  'auto',
    'marginRight'  :  'auto',
    'marginTop'   :  '1rem',
    'fontSize'     :  '2rem',
  },
};

const requiredAction = 'view_compose_email';

const ComposeEmail = ({id, commId, companyId, comms, requestComms}) => {
  const { topContainer, pageTitle } = styles;
  const [secId, setSecId] = useState('');
  useEffect(() => {
    requestComms();
  }, []);
  
  useEffect(() => {
    if (comms.length > 0){
      let intCommId = parseInt(commId);
      comms.forEach((comm) => {
        if (comm.sec_comm_id === intCommId){
          setSecId(comm.sec_id);
        }
      });
    }
  }, [comms]);

return (
  <AuthorizationWrapper requiredAction={requiredAction}>
    <div style={topContainer}>
      <Breadcrumb style={{marginBottom: 'auto'}}>
        <Breadcrumb.Item href="/security_incidents">Security Incidents</Breadcrumb.Item>
        <Breadcrumb.Item href={"/comms/" + secId}>Comms</Breadcrumb.Item>
        <Breadcrumb.Item href={"/emails/" + commId}>Emails</Breadcrumb.Item>
        <Breadcrumb.Item active>Email Composer</Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <div style={pageTitle}>Compose Email</div>
      </Row>
      {
        <div>
          <ComposeEmailTool id={id} commId={commId} company_id={companyId} />
        </div>
      }
    </div>
  </AuthorizationWrapper>
)
}

export default connect(mapStateToProps, mapDispatchToProps)(ComposeEmail);